<!-- <p>rules works!</p> -->

<div class="pageContainer">
    <div class="layoutItem">
        <span style="font-size: large; font-weight: bolder;">Rules</span>
        <span class="flex-spacer"></span>
        <div class="alignRow">
            <ejs-dropdownlist id="locationDropdown" #locationDropdown [dataSource]='dropdownLocations'
                placeholder="Select Location" [fields]="dropdownLocationFields"
                (change)="onQueryParameterChange('Location',$event)" [allowFiltering]="true"
                [(ngModel)]="this.filterQueryParams.Location" filterType="contains" [showClearButton]="true">
                <ng-template #itemTemplate let-data>
                    <div>
                        <span>{{data.Name}}</span>
                    </div>
                </ng-template>
            </ejs-dropdownlist>
        </div>
    </div>

    <div class="layoutItem">
        <ejs-tab id="element" [selectedItem]="selectedTabIndex"
            (selected)="onQueryParameterChange('selectedTab',$event)">
            <e-tabitems>
                <e-tabitem #rulesTab>
                    <ng-template #headerText>
                        <span class="alignRow app-icon app-icon--rules">
                            <mat-icon />&nbsp;Rules
                        </span>
                    </ng-template>
                    <ng-template #content>
                        <div>
                            <ng-container *ngTemplateOutlet="RulesTab"></ng-container>
                        </div>
                    </ng-template>
                </e-tabitem>
                <e-tabitem #rulesTab>
                    <ng-template #headerText>
                        <span class="alignRow app-icon app-icon--rules">
                            <mat-icon />&nbsp;Assets With No Rules
                        </span>
                    </ng-template>
                    <ng-template #content>
                        <div>
                            <ng-container *ngTemplateOutlet="NoRulesTab"></ng-container>
                        </div>
                    </ng-template>
                </e-tabitem>
            </e-tabitems>
        </ejs-tab>
    </div>
</div>

<ng-template #RulesTab>
    <ng-template #LoadingRules>
        <div class="waiting-container">
            <div class="item">
                <h2>Loading Rules</h2>
            </div>
        </div>
    </ng-template>
    <div style="display: flex; margin-bottom: 0.5em;">
        <span class="toolbar-spacer"></span>
        <span style="font-style: italic;">{{getFilterMessage()}}</span>
    </div>
    <div class="search-div alignRow">
        <div class="search-box">
            <mat-form-field>
                <mat-label>Search for a Rule or Asset</mat-label>
                <input matInput (keyup)="onQueryParameterChange('RulesFilter', $event)" placeholder="" #input
                    [(ngModel)]="filterQueryParams.RulesFilter">
            </mat-form-field>
        </div>
        <div class="location-dropdown">
            <button mat-raised-button [color]="hasFilters ? 'primary' : undefined" class="filter-button"
                [matMenuTriggerFor]="filterMenuRules">
                <span>Filters</span>
                <mat-icon>tune</mat-icon>
            </button>
        </div>
    </div>
    <ng-container *ngIf="rulesReturned else LoadingRules">
        <table mat-table matSort #tableRules #sortRules="matSort" [dataSource]="dataSourceRules"
            (matSortChange)="onQueryParameterChange('RulesSortColumn',$event)"
            [matSortActive]="filterQueryParams.RulesSortColumn || 'AssetName'"
            [matSortDirection]="filterQueryParams.RulesSortDirection || 'asc'">
            <ng-container matColumnDef="RuleDescription">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Rule Name</th>
                <td style="font-weight: bolder;" mat-cell *matCellDef="let row" (click)="GoToRule(row)">
                    {{row.RuleDescription}} </td>
            </ng-container>
            <ng-container matColumnDef="condition">
                <th mat-header-cell *matHeaderCellDef>Condition</th>
                <td mat-cell *matCellDef="let row" (click)="GoToRule(row)">
                    {{row.ReadableRule}} </td>
            </ng-container>
            <ng-container matColumnDef="AssetName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Asset</th>
                <td mat-cell *matCellDef="let row" (click)="GoToRule(row)"> {{
                    row.AssetName }}
                </td>
            </ng-container>
            <ng-container matColumnDef="lastTriggered">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Last Triggered</th>
                <td mat-cell *matCellDef="let row" (click)="GoToRule(row)">
                    <span *ngIf="row.LastTriggered == 0">Never</span>
                    <span *ngIf="row.LastTriggered > 0">{{ convertEpoch(row.LastTriggered) }}</span>
                </td>
            </ng-container>
            <ng-container matColumnDef="eventsInPast30Days">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Events In Past 30 Days</th>
                <td mat-cell *matCellDef="let row" (click)="GoToRule(row)">
                    <span *ngIf="row.EventsInPast30Days == 0">No Events</span>
                    <span *ngIf="row.EventsInPast30Days > 0">{{ row.EventsInPast30Days }}</span>
                </td>
            </ng-container>

            <ng-container matColumnDef="CMMSEnabled">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>CMMS Enabled</th>
                <td mat-cell *matCellDef="let row" (click)="GoToRule(row)">
                    <mat-icon *ngIf="row.CMMSEnabled" style="color: lightgreen;">check</mat-icon>
                    <mat-icon *ngIf="!row.CMMSEnabled" style="color: salmon;">close</mat-icon>
                </td>
            </ng-container>

            <ng-container matColumnDef="buttons">
                <th mat-header-cell *matHeaderCellDef>Options</th>
                <td mat-cell *matCellDef="let row">
                    <button mat-icon-button [matMenuTriggerFor]="RuleOptionsMenu" [matMenuTriggerData]="{ row: row }">
                        <mat-icon>more_horiz</mat-icon>
                    </button>
                    <mat-menu #RuleOptionsMenu>
                        <button mat-menu-item (click)="getAssetForRule(row, $event)" class="app-icon app-icon--edit">
                            <mat-icon /><span>Edit</span>
                        </button>
                        <button mat-menu-item (click)="deleteRule(row)" class="app-icon app-icon--delete">
                            <mat-icon /><span>Delete</span>
                        </button>
                    </mat-menu>
                </td>
            </ng-container>
            <ng-container matColumnDef="GoToAsset">
                <th mat-header-cell *matHeaderCellDef></th>
                <td style="cursor: pointer; font-weight: bolder;" mat-cell *matCellDef="let row" class="app-icon--goto"
                    (click)="goToAsset(row)">
                    <mat-icon matTooltip="Go To Asset" />
                </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="filteredRuleTableColumns"></tr>
            <tr mat-row class="table-row" [ngStyle]="{'color': !row.RuleEnabled ? 'grey' : ''}" style="cursor: pointer;"
                [ngClass]="{'active-rule': row.Active}" *matRowDef="let row; columns: filteredRuleTableColumns;"></tr>
            <tr class="mat-row" *matNoDataRow>
                <td *ngIf="input.value != ''" class="mat-cell" colspan="7">No Data Matching the Filter:
                    "{{input.value}}"</td>
                <td *ngIf="input.value == ''" class="mat-cell" colspan="7">No Data Matching the Filter</td>
            </tr>
        </table>
        <mat-paginator #paginatorRules [pageSizeOptions]="[10, 15, 20, 25, 50]"
            [pageSize]="filterQueryParams.RulespageSize ?? 10" [pageIndex]="filterQueryParams.RulespageIndex"
            (page)="onPageChange(paginatorRules, $event)" aria-label="Select page of rules"></mat-paginator>
    </ng-container>
</ng-template>

<ng-template #NoRulesTab>
    <ng-template #LoadingAssets>
        <div class="waiting-container">
            <div class="item">
                <h2>Loading Assets</h2>
            </div>
        </div>
    </ng-template>
    <div style="display: flex; margin-bottom: 0.5em;">
        <span class="toolbar-spacer"></span>
        <span style="font-style: italic;">{{getLocationMessage()}}</span>
    </div>

    <div class="search-div alignRow">
        <div class="search-box">
            <mat-form-field>
                <mat-label>Search for an Asset</mat-label>
                <input matInput (keyup)="onQueryParameterChange('AssetsFilter',$event)" placeholder="" #input
                    [(ngModel)]="filterQueryParams.AssetsFilter">
            </mat-form-field>
        </div>
    </div>
    <ng-container *ngIf="assetsReturned else LoadingAssets">
        <table mat-table matSort #tableAssets #sortAssets="matSort" [dataSource]="dataSourceAssets"
            (matSortChange)="onQueryParameterChange('AssetsSortColumn',$event)"
            [matSortActive]="filterQueryParams.AssetsSortColumn || 'Name'"
            [matSortDirection]="filterQueryParams.AssetsSortDirection || 'asc'">
            <ng-container matColumnDef="Name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Asset Name</th>
                <td style="font-weight: bolder;" mat-cell *matCellDef="let row">
                    {{row.Name}} </td>
            </ng-container>
            <ng-container matColumnDef="Description">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Description</th>
                <td mat-cell *matCellDef="let row">
                    {{row.Description}} </td>
            </ng-container>

            <ng-container matColumnDef="HierarchyPath">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>HierarchyPath</th>
                <td mat-cell *matCellDef="let row">
                    {{row.HierarchyPath}} </td>
            </ng-container>

            <ng-container matColumnDef="Buttons">
                <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
                <td mat-cell *matCellDef="let row">
                    <button mat-raised-button (click)="ManageRules(row)">
                        <!-- <mat-icon>more_horiz</mat-icon> -->
                        <span>Manage</span>
                    </button>
                </td>
            </ng-container>
            <ng-container matColumnDef="GoToAsset">
                <th mat-header-cell *matHeaderCellDef></th>
                <td style="cursor: pointer; font-weight: bolder;" mat-cell *matCellDef="let row" class="app-icon--goto"
                    (click)="goToAsset(row)">
                    <mat-icon matTooltip="Go To Asset" />
                </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="filteredAssetTableColumns"></tr>
            <tr mat-row class="table-row" *matRowDef="let row; columns: filteredAssetTableColumns;"></tr>
            <tr class="mat-row" *matNoDataRow>
                <td *ngIf="input.value != ''" class="mat-cell" colspan="6">No Data Matching the Filter:
                    "{{input.value}}"</td>
                <td *ngIf="input.value == ''" class="mat-cell" colspan="6">No Data Matching the Filter</td>
            </tr>
        </table>
        <mat-paginator #paginatorAssets [pageSizeOptions]="[10, 15, 20, 25, 50]"
            [pageSize]="filterQueryParams.AssetspageSize ?? 10" [pageIndex]="filterQueryParams.AssetspageIndex"
            (page)="onPageChange(paginatorAssets, $event)" aria-label="Select page of Assets"></mat-paginator>
    </ng-container>
</ng-template>


<mat-menu #filterMenuRules>
    <div class="filter-switch-div">
        <div class="enabled-switch-div" [ngClass]="{'disabled-checkbox': filterQueryParams.Disabled}">
            <span style="margin-right: 0.2em;">Enabled</span>
        </div>
        <mat-checkbox color="primary" (click)="$event.stopPropagation()"
            (change)="onQueryParameterChange('Enabled', $event)" [(ngModel)]="filterQueryParams.Enabled"
            [disabled]="filterQueryParams.Disabled == true"></mat-checkbox>

        <div class="enabled-switch-div"
            [ngClass]="{'disabled-checkbox': filterQueryParams.Enabled || filterQueryParams.Active}">
            <span style="margin-right: 0.2em;">Disabled</span>
        </div>
        <mat-checkbox color="primary" (click)="$event.stopPropagation()"
            (change)="onQueryParameterChange('Disabled',$event)" [(ngModel)]="filterQueryParams.Disabled"
            [disabled]="filterQueryParams.Enabled == true || filterQueryParams.Active == true"></mat-checkbox>

        <div class="active-switch-div">
            <span style="margin-right: 0.2em;">CMMS Enabled</span>
        </div>
        <mat-checkbox color="primary" (click)="$event.stopPropagation()" [(ngModel)]="filterQueryParams.CMMS"
            (change)="onQueryParameterChange('CMMS',$event)"></mat-checkbox>

        <div class="active-switch-div" [ngClass]="{'disabled-checkbox': filterQueryParams.Disabled}">
            <span style="margin-right: 0.2em;">Active</span>
        </div>
        <mat-checkbox color="primary" (click)="$event.stopPropagation()"
            (change)="onQueryParameterChange('Active',$event)" [(ngModel)]="filterQueryParams.Active"
            [disabled]="filterQueryParams.Disabled == true"></mat-checkbox>

    </div>

</mat-menu>